import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appCyData]',
  standalone: false
})

export class CyDirective {
  @Input() appCyData?: string;
}